/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  dropdown: [],
  manufacturerList: [],
  checkDetails: [],
  errorMessagesInRedux: [],
  successMessageInRedux: [],
  calInterestObj: {},
  getAllCalculateInterestList: [],
  getAllVerifyCalInterestList: [],
  quarter: '',
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_COMMON_DROPDOWN_DATA_CI:
      return {
        ...state,
        dropdown: action.dropdown,
      };
    case actionTypes.NETWORK_ERROR_CALC_INT:
      return { ...state, apiFailedErr: action.payload };
    case actionTypes.CALCULATE_INTEREST_TAB_DATA:
      return {
        ...state,
        calInterestObj: action.calInterestObj,
      };
    case actionTypes.DETAIL_DATA_CAL_INT:
      return { ...state, details_for_dsn: action.payload };
    case actionTypes.GET_MANUFACTURER_GRID_LIST:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };
    case actionTypes.GET_CALCULATE_INTEREST_FOR_NDC_MFG:
      return {
        ...state,
        getAllCalculateInterestList: action.getAllCalculateInterestList,
      };
    case actionTypes.GET_VALIDATION_CALCULATE_INTEREST:
      return {
        ...state,
        getAllVerifyCalInterestList: action.getAllVerifyCalInterestList,
      };
    case actionTypes.SELECTED_REBATE_PROGRAM:
      return {
        ...state,
        selectedRebateProgram: action.selectedRebateProgram,
      };
    case actionTypes.GET_QUARTER_DATA:
      return {
        ...state,
        quarter: action.quarter,
      };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_CAL_INT:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.HANDLE_SUCCESS_MESSAGE_FOR_CAL_INT:
      return { ...state, successMessageInRedux: action.successMessageInRedux };
    default:
      return state;
  }
};

export default reducer;
